import { Route, Routes, Switch } from "react-router-dom";

import AdminConsulta from "../content/callcenter/adminconsulta/AdminConsulta.js";
import Anuncio from "../content/administracion/anuncio/Anuncio";
import CallCenter from "../content/callcenter/callcenter/CallCenter";
import Colaborador from "../content/administracion/colaboradores/Colaborador";
import Cupon from "../content/administracion/cupon/Cupon";
import Empresa from "../content/administracion/empresa/Empresa";
import Especialidad from "../content/administracion/especialidad/Especialidad";
import Folio from "../content/folio/Folio";
import { Fragment } from "react";
import MeditocDrawerLeft from "./MeditocDrawerLeft";
import MeditocFooter from "./MeditocFooter";
import MeditocNavBar from "./MeditocNavBar";
import MeditocPortada from "./MeditocPortada";
import MisConsultas from "../content/callcenter/misconsultas/MisConsultas";
import MotivoConsulta from "../content/administracion/motivoconsulta/MotivoConsulta";
import Perfil from "../content/configuracion/perfil/Perfil";
import Producto from "../content/administracion/producto/Producto";
import ReporteDoctores from "../content/reportes/doctores/ReporteDoctores";
import ReporteVentas from "../content/reportes/ventas/ReporteVentas";
import Sistema from "../content/configuracion/sistema/Sistema";
import Usuario from "../content/configuracion/usuario/Usuario";
import { urlSystem } from "../../settings/urlConfig";

export default function MeditocContent() {
    return (
        <Fragment>
            <div className="flx-grw-1 pos-rel">
                <MeditocNavBar />
                <MeditocDrawerLeft />
                <div>
                    <Switch>
                        <Route exact path="/" component={MeditocPortada}></Route>
                        <Route exact path={urlSystem.login} component={MeditocPortada}></Route>
                        <Route exact path={urlSystem.configuracion.usuarios} component={Usuario}></Route>
                        <Route exact path={urlSystem.configuracion.perfiles} component={Perfil}></Route>
                        <Route exact path={urlSystem.configuracion.sistema} component={Sistema}></Route>
                        <Route exact path={urlSystem.administracion.colaboradores} component={Colaborador}></Route>
                        <Route exact path={urlSystem.administracion.institucion} component={Empresa}></Route>
                        <Route exact path={urlSystem.administracion.productos} component={Producto}></Route>
                        <Route exact path={urlSystem.administracion.cupones} component={Cupon}></Route>
                        <Route exact path={urlSystem.administracion.especialidades} component={Especialidad}></Route>
                        <Route exact path={urlSystem.folios.folios} component={Folio}></Route>
                        <Route exact path={urlSystem.callcenter.consultas} component={CallCenter}></Route>
                        <Route exact path={urlSystem.callcenter.consultas + "/*"} component={CallCenter}></Route>
                        <Route exact path={urlSystem.callcenter.administrarConsultas} component={AdminConsulta}></Route>
                        <Route exact path={urlSystem.callcenter.misconsultas} component={MisConsultas}></Route>
                        <Route exact path={urlSystem.reportes.ordenes} component={ReporteVentas}></Route>
                        <Route exact path={urlSystem.reportes.doctores} component={ReporteDoctores}></Route>
                        <Route exact path={urlSystem.administracion.anuncios} component={Anuncio}></Route>
                        <Route exact path={urlSystem.administracion.motivosconsulta} component={MotivoConsulta}></Route>
                    </Switch>
                </div>
            </div>
            <MeditocFooter />
        </Fragment>
    );
}
